import React from 'react';

import ProgressReportIndex from '../containers/ProgressReportIndex.jsx';
import DemoAccountContextProvider from '../contexts/DemoAccountContextProvider';

export default ({ isDemo = false, ...props }) => (
  <DemoAccountContextProvider isDemo={isDemo}>
    <ProgressReportIndex {...props} />
  </DemoAccountContextProvider>
);
